<script>
export default {
  name: 'GridSix',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 8.60469H9.75V2.80469H16.19C19.83 2.80469 22 4.97469 22 8.60469Z"
      :fill="color"
    />
    <path
      d="M22 17.1055C21.95 20.6755 19.79 22.8055 16.19 22.8055H9.75V17.1055H22Z"
      :fill="color"
    />
    <path
      d="M8.25 2.80469V22.8047H7.81C4.17 22.8047 2 20.6347 2 16.9947V8.61469C2 4.97469 4.17 2.80469 7.81 2.80469H8.25Z"
      :fill="color"
    />
    <path d="M22 10.1055H9.75V15.6055H22V10.1055Z" :fill="color" />
  </svg>
</template>
